import { GateMovementState2 } from '@/__generated__/graphql';
import { isFinalizedState } from './gateMovementFinalized';

type MovementSnapshot = { id: number; state: GateMovementState2 } | null | undefined;

/**
 * ¿Este mensaje cambia qué movimientos están en curso? Solo entonces vale la pena refetchear la
 * lista: un GO06 llega cada ~3 s por compuerta en movimiento y su avance ya lo actualiza el cache.
 *
 * Cambia si un movimiento no terminal no está en la lista, o si uno terminal todavía está.
 */
export const changesActiveMembership = (
  activeIds: ReadonlySet<number>,
  movements: readonly MovementSnapshot[],
) =>
  movements.some((movement) => {
    if (!movement) return false;
    const listed = activeIds.has(movement.id);
    return isFinalizedState(movement.state) ? listed : !listed;
  });

/**
 * Throttle con llamada inicial y una final garantizada: la primera ejecuta al instante, las que
 * llegan dentro de la ventana se colapsan en una sola al cerrarla. Sin la final, el último cambio
 * de una ráfaga se perdería.
 */
export const createThrottle = (fn: () => void, windowMs: number) => {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let pending = false;

  const open = () => {
    timer = setTimeout(() => {
      timer = null;
      if (!pending) return;
      pending = false;
      fn();
      open();
    }, windowMs);
  };

  return {
    call() {
      if (timer) {
        pending = true;
        return;
      }
      fn();
      open();
    },
    cancel() {
      if (timer) clearTimeout(timer);
      timer = null;
      pending = false;
    },
  };
};
